// This is copied in the build process in .gitlab-ci.yml.
// To test it with the development serve process,
// manually copy it to /projects/src/environments/environment.ts

export const environment = {
  name: 'tagesraetsel', // Just for information and logging purposes.
  production: true,
  firebase: {
    apiKey: 'AIzaSyAHEtltDQ8riRGXFrjvZCeTTgPslIS1fz4',
    authDomain: 'leaderboard-tagesraetsel.firebaseapp.com',
    projectId: 'leaderboard-tagesraetsel',
    storageBucket: 'leaderboard-tagesraetsel.appspot.com',
    messagingSenderId: '197845221405',
    appId: '1:197845221405:web:09002e3e92e0d9fcf9c6f4',
    measurementId: 'G-E4PYCM9TS2',
  },
  // Sentry Config: https://docs.sentry.io/platforms/javascript/guides/angular
  sentry: {
    dsn: 'https://025fbb60fd490b0cbcb9c6aa11a04086@o4509349463457792.ingest.de.sentry.io/4509349468635216',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: false,
    environment: 'projects/tagesraetsel',
  },
};
